export const transformVideoUrl = (url: string): string => {
  // Handle YouTube watch, short, and embed URLs in one regex
  const youtubeRegex = /(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([^&\n?#]+)/;
  const match = url.match(youtubeRegex);

  if (match) {
    return `https://www.youtube.com/embed/${match[1]}?color=white&playsinline=1`;
  }
  // Return the original URL for non-YouTube formats
  return url;
};
